import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {},
};

const imageSlice = createSlice({
  name: "image",
  initialState,
  reducers: {
    getDeletedImage: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { getDeletedImage } = imageSlice.actions;
export default imageSlice.reducer;
